import _ from 'lodash';

import {React, Page, Component, component, HBox, VBox, TopBanner} from '../Page';

import Avatar from '../../Avatar';
import {ArrowRight, Skype} from '../../icons';
import Flag from '../../Flag';
import {TableListRow, TableListCell} from '../../TableList';
import AddComplaintPopup from './AddComplaintPopup';
import ClaimResultsPopup from './ClaimResultsPopup';
import Link from './../../Link';
import ActionButton from './../../ActionButton';
import DataEditButton from './../../DataEditButton';

import {dateTime, dateTimeYear} from './../../DateFormats';

import {summGameResults} from './../../GamesItem.js';

const STATUS = {
  CREATED: 1,
  STARTED: 2,
  ABSENCE: 3,
  CANCELED: 4,
  FINISHED: 5,
  PUBLISHED: 6
};


const ROLE = {
  CAPTAIN: 1,
  MAIN: 2,
  RESERVE: 3
};


class TeamMemberRow extends Component {

  renderLoaded({member}) {
    const avatar = member.getIn(['user', 'image']) || require('../../../img/teamEmptyAvatarSquare.png');

    const bgImage = avatar
      ? avatar + '?crop=1&w=104&h=104'
      : require('../../../img/teamEmptyAvatarSquare.png');
    return (
      <TableListRow height={104}>
        <TableListCell width={104} type='Logo'>
          <Link name='playerDetails' className="TableListCell-Avatar"  params={{id: member.getIn(['user', 'id'])}} style={{
            backgroundImage: `url(${bgImage})`,
            width: 104,
            height: 104
          }} />
        </TableListCell>
        <TableListCell width={320} type='Primary'>
          <div className='GameDetails-TeamInfo'>
            <div className='GameDetails-TeamTitleCountry'>
              <Link name='playerDetails' params={{id: member.getIn(['user', 'id'])}} className='GameDetails-TeamTitle'>{member.getIn(['user', 'nickname'])}</Link>
              {
                member.getIn(['user', 'country']) &&
                  <div className='GameDetails-TeamCountry'>
                    <Flag country={member.getIn(['user', 'country'])} outputName />
                  </div>
              }
            </div>
          </div>
        </TableListCell>
      </TableListRow>
    );
  }

}


class TeamMemberList extends Component {

  renderLoaded({members}) {
    if(!members){ return null; }
    const activeMembers = members.filter(member => member.get('role') !== ROLE.RESERVE).sortBy(member => member.get('role'));
    return (
      <VBox width={2} container>
        {activeMembers.map((member, idx) => <TeamMemberRow member={member} key={idx} />)}
      </VBox>
    );
  }

}


class JudgeComment extends Component {

  renderLoaded({gameData}) {
    if (!gameData.hasData('comment')) {
      return null;
    }
    return (
      <div className="GameDetails-JudgeComment">
        <i className="GameDetails-JudgeCommentArrow" />
        <div className="GameDetails-Caption">комментарий судьи</div>
        <div className="GameDetails-JudgeCommentText">{gameData.get('comment')}</div>
      </div>
    );
  }

}


class MapsItem extends Component {

  renderLoaded({gameData, index}) {
    return (
      <li className="GameDetails-MapsItem">
        <div className="GameDetails-Caption">{gameData.getIn(['maps', index, 'title'])}</div>
        <div className="GameDetails-MapsValue">{gameData.getIn(['results', index, 'team_a_score']) || '—'}:{gameData.getIn(['results', index, 'team_b_score']) || '—'}</div>
      </li>
    );
  }

}

class ResultsItem extends Component {

  renderLoaded({gameData, index}) {
    return (
      <li className="GameDetails-MapsItem">
        <div className="GameDetails-Caption">{gameData.getIn(['results', index, 'map', 'title'])}</div>
        <div className="GameDetails-MapsValue">{gameData.getIn(['results', index, 'team_a_score'])}:{gameData.getIn(['results', index, 'team_b_score'])}</div>
      </li>
    );
  }

}




class JudjeInfo extends Component {
  renderLoaded({gameData}) {

    let userPic = gameData.getIn(['judge', 'image']);
    userPic = userPic ? userPic+'?crop=1&w=68&h=68' : require('./../../../img/teamEmptyAvatarSquare.png');

    let judgeContact = gameData.getIn(['judge', 'contact']);

    return (
      <div className="GameDetails-Judge">
        <div className="GameDetails-JudgeAvatar" style={{
          backgroundImage: `url(${userPic})`
        }}></div>
        <div className="GameDetails-Caption">судья матча</div>
        <div className="GameDetails-JudgeName">{gameData.getIn(['judge', 'nickname'])}</div>
        {judgeContact &&
          <div className='Avatar-Skype'>
            <div className="GameDetails-JudgeName--Skype">
              <span className="Avatar-SkypeIcon">
                <Skype />
              </span>
              <span className="Avatar-CaptionTitle">
                {judgeContact}
              </span>
            </div>
          </div>
        }
      </div>
    );
  }

}


class FinishedGameState extends Component {

  renderLoaded({gameData, buttons}) {
    const results = summGameResults(gameData.get('results').toJS());
    return (
      <div className='GameDetails-GameState'>
        <ul className="GameDetails-Maps">
          {gameData.get('results').map((result, index) =>
            <ResultsItem gameData={gameData} key={index} index={index} />
          )}
        </ul>
        <div className="GameDetails-Score">
          <div className="GameDetails-ScoreValue">
            <div className="GameDetails-Caption">общий счет</div>
            {results[0]}:{results[1]}
          </div>
        </div>
        {buttons.claimResults}
        <JudjeInfo gameData={gameData} />
        {buttons.complaint}
      </div>
    );
  }

}


class StartedGameState extends Component {

  renderLoaded({gameData, buttons}) {
    return (
      <div className='GameDetails-GameState'>
        <ul className="GameDetails-Maps">
          {gameData.get('maps').map((map, index) =>
              <MapsItem gameData={gameData} key={index} index={index} />
          )}
        </ul>
        <div className='GameDetails-StartedCaption'>Матч начат</div>
        {buttons.claimResults}
        <JudjeInfo gameData={gameData} />
        {buttons.complaint}
      </div>
    );
  }

}

class NewGameState extends Component {

  renderLoaded({gameData}) {
    return (
      <div className='GameDetails-GameState'>
        <ul className="GameDetails-Maps">
          {gameData.get('maps').map((map, index) =>
              <MapsItem gameData={gameData} key={index} index={index} />
          )}
        </ul>
        <div className="GameDetails-Score">
          <div className="GameDetails-ScoreValue">
            —:—
          </div>
        </div>
        <JudjeInfo gameData={gameData} />
      </div>
    );
  }

}

class GameState extends Component {

  renderLoaded({gameData, buttons}) {
    const status = gameData.get('status');
    switch (status) {
      case STATUS.CREATED:
        return <NewGameState gameData={gameData} />;
        break;
      case STATUS.FINISHED:
        return <FinishedGameState gameData={gameData} buttons={buttons}/>;
        break;
      case STATUS.STARTED:
        return <StartedGameState gameData={gameData} buttons={buttons}/>;
        break;
      default:
        return <div className='GameDetails-GameState' />;
    }
  }

}


export default class GameDetails extends Page {

  constructor() {
    super();
    this.state = {
      showComplaintsPopup: false,
      showResultsPopup: false
    }
  }

  showComplaintsPopup() {
    this.setState({
      showComplaintsPopup: true
    });
  }

  hideComplaintsPopup() {
    this.setState({
      showComplaintsPopup: false
    });
  }

  showResultsPopup() {
    this.setState({
      showResultsPopup: true
    });
  }

  hideResultsPopup() {
    this.setState({
      showResultsPopup: false
    });
  }

  getDataPath() {
    return ['gameData', this.props.gameId];
  }

  renderLoaded({data, gameId}) {
    const gameData = data.cursor(['gameData', gameId]);
    const user = data.get('user');
    const gameStatus = gameData.get('status');

    const changeable =
      user
      &&
      user.get('member_role') === ROLE.CAPTAIN
      && (
        gameData.get('members_a') && gameData.get('members_a').find(x => x.getIn(['user', 'id']) === user.get('id'))
        ||
        gameData.get('members_b') && gameData.get('members_b').find(x => x.getIn(['user', 'id']) === user.get('id'))
      );

    const canClaimResults = changeable && (gameStatus === STATUS.STARTED);
    const canComplaint = changeable && (gameStatus === STATUS.STARTED);

    const buttons = {
      claimResults: canClaimResults && <DataEditButton text='Отправить результаты матча'
                                                     className='GameDetails-Button GameDetails-ButtonClaimResults'
                                                     onClick={this.showResultsPopup.bind(this)} />,
      complaint: canComplaint && <DataEditButton text='Отправить жалобу судье'
                                               className='GameDetails-Button GameDetails-ButtonComplaint'
                                               onClick={this.showComplaintsPopup.bind(this)} />
    };


    const teamAName = gameData.getIn(['team_a', 'title']) || 'пустое место';
    const teamBName = gameData.getIn(['team_b', 'title']) || 'пустое место';

    const teamAImage = gameData.getIn(['team_a', 'image']) || require('../../../img/teamEmptyAvatarSquare.png');
    const teamBImage = gameData.getIn(['team_b', 'image']) || require('../../../img/teamEmptyAvatarSquare.png');

    const date = (
      gameStatus === STATUS.CREATED || gameStatus === STATUS.STARTED ?
        dateTime(gameData.get('started_at')) :
        dateTimeYear(gameData.get('started_at'))
    );

    return (
      <div className='GameDetails'>
        <TopBanner data={data} size='regular'>
            <div className='GameDetails-Header'>
              <div className='GameDetails-Date'>
                {date}
              </div>
              <div className='GameDetails-League'>
                <Link name="tournamentDetails" params={{id: gameData.get('tournament_id')}}>
                  {gameData.get('tournament_title')}
                  <ArrowRight className='GameDetails-Arrow'/>
                </Link>
              </div>
              <div className='GameDetails-TeamsInfo'>
                <Link className="GameDetails-TeamAvatar" name="teamDetails" params={{id: gameData.getIn(['team_a', 'id'])}}>
                  <Avatar customClass="Game" type='Team' data={gameData.cursor('team_a')} />
                </Link>
                <GameState gameData={gameData} buttons={buttons}/>
                <Link className="GameDetails-TeamAvatar" name="teamDetails" params={{id: gameData.getIn(['team_b', 'id'])}}>
                  <Avatar customClass="Game" type='Team' data={gameData.cursor('team_b')} />
                </Link>
              </div>
            </div>
        </TopBanner>
        <JudgeComment gameData={gameData} />
        <HBox width={4} container>
          <TeamMemberList members={gameData.get('members_a')} />
          <TeamMemberList members={gameData.get('members_b')} />
        </HBox>
        {
          this.state.showComplaintsPopup &&
            <AddComplaintPopup gameData={gameData} onClose={this.hideComplaintsPopup.bind(this)} />
        }
        {
          this.state.showResultsPopup &&
            <ClaimResultsPopup gameData={gameData} onClose={this.hideResultsPopup.bind(this)} />
        }
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/pages/GameDetails/index.js